import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import styled from 'astroturf/react';
import _Container from "Button-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/design_system/Button.tsx?styleId=Container";


export const Container = /*#__PURE__*/styled("button", null, {
  displayName: "Container",
  styles: _Container
});

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: 'lg' | 'sm' | 'xs';
  variant?:
    | 'primary'
    | 'primary-dark'
    | 'secondary'
    | 'inverse'
    | 'inverse-gray'
    | 'text'
    | 'text-gray';
  weight?: 'medium' | 'regular';
  icon?: ReactNode;
  iconOnlyBreakpoint?: 'sm' | 'md' | 'lg';
};

export const Button: React.FC<ButtonProps> = ({
  size = 'sm',
  variant = 'primary',
  weight = 'medium',
  icon,
  iconOnlyBreakpoint,
  children,
  ...props
}) => {
  return (
    <Container
      size={size}
      variant={variant}
      weight={weight}
      icononlybreakpoint={icon ? iconOnlyBreakpoint : undefined}
      {...props}
    >
      {icon}
      {children && <span>{children}</span>}
    </Container>
  );
};
